import Listing from 'app/shared/model/Listing';

const TemplateValues = ({
    DestinationUrl = '',
    ImageBrandRectangle = '',
    ImageBrandSquare = '',
    ImageLogo = '',
    ListDisplayEHOImage = '',
    ListDisplayLogo = '',
    ListFlagOptions = '',
    ListHeaderText = '',
    TextCTA = '',
    TextHeader = '',
    TextListingType = '',
    TextSlug = '',
    TextSubheader01 = '',
    TextSubheader02 = '',
    TextSubheader03 = '',
    URLClickthroughZillowWeb = '',
} = {}) => ({
    destinationUrl: String(DestinationUrl),
    imageBrandRectangle: String(ImageBrandRectangle),
    imageBrandSquare: String(ImageBrandSquare),
    imageLogo: String(ImageLogo),
    listDisplayEHOImage: String(ListDisplayEHOImage),
    listDisplayLogo: String(ListDisplayLogo),
    listFlagOptions: String(ListFlagOptions),
    listHeaderText: String(ListHeaderText),
    textCTA: String(TextCTA),
    textHeader: String(TextHeader),
    textListingType: String(TextListingType),
    textSlug: String(TextSlug),
    textSubheader01: String(TextSubheader01),
    textSubheader02: String(TextSubheader02),
    textSubheader03: String(TextSubheader03),
    urlClickthroughZillowWeb: String(URLClickthroughZillowWeb),
});

const DfpPreview = ({
    creativeTemplateType = '',
    templateValues = {},
} = {}) => ({
    creativeTemplateType: String(creativeTemplateType),
    templateValues: new TemplateValues(templateValues),
});

const BoostAdPreviews = ({
    propertyDetails = {},
    previews = [],
    dfpPreview = {},
    isActive = true,
} = {}) => ({
    propertyDetails: new Listing(propertyDetails),
    previews,
    dfpPreview: new DfpPreview(dfpPreview),
    isActive: Boolean(isActive),
});

export default BoostAdPreviews;
